import React, { useCallback, useEffect, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { imgLoad } from '@chat/utils';
import Questions from '@/components/Questions';
import Resolve from '@/components/Resolve';
import Art from '@/components/Art';
import Notice from '@/components/MessageList/Notice';
import Msg from '@/components/MessageList/Msg';
import Offline from '@/components/Offline';
import { IM_MESSAGE } from '@/typings/global';
import { MESSAGE_TYPE } from '@/config/enum';
import Loading from './Loading';

function index(): JSX.Element {
    const { message_list } = useSelector(
        ({ IMReducer }) => ({
            message_list: IMReducer.message_list
        }),
        shallowEqual
    );
    const messageEnd = useRef(null); // 滚动区域
    // 滚动到底部
    const scrollToEnd = () => {
        const _scroll = () => {
            const { scrollHeight } = messageEnd.current;
            const height = messageEnd.current.clientHeight;
            const maxScrollTop = scrollHeight - height;
            messageEnd.current.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
        };
        imgLoad(messageEnd.current, _scroll);
    };
    // 渲染消息
    const _rendermessage = useCallback((item: IM_MESSAGE) => {
        // if(item.type==='in'){
        //     item = {
        //         ...item,
        //         type: "CLOSE_NOGM",
        //     }
        // }
        const msgSwiper = {
            [MESSAGE_TYPE.info]: <Notice {...item} />,
            [MESSAGE_TYPE.succ]: <Notice {...item} />,
            [MESSAGE_TYPE.error]: <Notice {...item} />,
            [MESSAGE_TYPE.warn]: <Notice {...item} />,
            [MESSAGE_TYPE.bugle]: <Notice {...item} />,
            [MESSAGE_TYPE.in]: <Msg {...item} />,
            [MESSAGE_TYPE.out]: <Msg {...item} />,
            [MESSAGE_TYPE.offline]: <Offline {...item} />,
            // faq
            [MESSAGE_TYPE['faq-init']]: <Questions {...item} />,
            [MESSAGE_TYPE['faq-questions']]: <Questions {...item} />,
            [MESSAGE_TYPE['faq-resolve']]: <Resolve {...item} />,
            [MESSAGE_TYPE['faq-art']]: <Art {...item} />,
            [MESSAGE_TYPE['faq-loading']]: <Loading {...item} />
        };
        return msgSwiper[item.type];
    }, []);

    // 新消息滚动操作
    useEffect(() => {
        scrollToEnd();
    }, [message_list]);

    window.IM.scrollToEnd = scrollToEnd;

    return (
        <ul className={classnames('im-message-list')} ref={messageEnd}>
            {message_list.map((item) => _rendermessage(item))}
        </ul>
    );
}

export default index;
